import PropTypes from 'prop-types';

const TableCell = (props) => {
  const {
    action,
    align = 'left',
    children,
    className = '',
    rowSpan = '',
    colSpan = '',
    fullBorder = false,
    bottomlessBorder = false,
    toplessBorder = false,
    borderless = false,
    boldText,
    width = '',
    forceCenter,
    padding = '',
    background = '',
  } = props;

  return (
    <td
      style={{ width: width, textAlign: forceCenter ? '-webkit-center' : '', padding: padding, backgroundColor: background }}
      onClick={action}
      rowSpan={rowSpan}
      colSpan={colSpan}
      className={`${'table-cell-' + align} ${className} ${borderless && 'borderless'} ${toplessBorder && 'topless-border'} ${
        bottomlessBorder && 'bottomless-border'
      } ${fullBorder && 'full-border'} ${boldText && 'bold-text-3 text-gray-davys'}`}
    >
      {children}
    </td>
  );
};

TableCell.propTypes = {
  align: PropTypes.string,
  action: PropTypes.func,
  width: PropTypes.string,
  forceCenter: PropTypes.bool,
  fullBorder: PropTypes.bool,
  bottomlessBorder: PropTypes.bool,
  toplessBorder: PropTypes.bool,
};

export default TableCell;
